import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { SET_TAB_INDEX, SET_VISIBLE_TABS } from './constants';

const initialState = {
  tabIndex: 0,
  visibileTabs: [],
};

export const tabsReducer = createReducer(initialState, {
  [SET_TAB_INDEX]: (state, action) => {
    return { tabIndex: action.payload };
  },
  [SET_VISIBLE_TABS]: (state, action) => {
    return { visibleTabs: action.payload };
  },
});
